import { textStyles } from '#@/shared/utils/styles';

export const bodyVariants = {
  large: textStyles.bodyLarge450,
  medium: textStyles.bodyMedium450,
  small: textStyles.bodySmall450,
  compact: textStyles.bodyCompact450,
};

export const labelVariants = {
  large: textStyles.labelLarge500,
  large450: textStyles.labelLarge450,
  medium: textStyles.labelMedium500,
  small: textStyles.labelSmall500,
  compact: textStyles.labelCompact500,
};

export const titleVariants = {
  large: textStyles.titleLarge700,
  medium: textStyles.titleMedium700,
  small: textStyles.titleSmall500,
  section: textStyles.sectionTitle700,
};
